const SEVERITY_FACTORS = [1000, 300, 100, 30, 10, 0];

const toRows = (descriptions) => descriptions.map((description, index) => {
  const level = 5 - index;
  return [level, description, SEVERITY_FACTORS[5 - level]];
});

const MFL_DESCRIPTIONS_V1 = {
  mfl_health_and_safety: toRows([
    '6 o más fatalidades, o 6 o más enfermedades que acortan la vida.',
    '1-5 fatalidades o 1-5 enfermedades que acortan la vida.',
    'Incapacidad permanente/de largo plazo, o lesión o enfermedad que altere la vida de una o más personas.',
    'Lesión o enfermedad que no altera la vida, o de corto plazo de una o más personas.',
    'Impactos de bajo nivel que solo requieren primeros auxilios.',
    'No aplica.',
  ]),
  mfl_environment: toRows([
    'Impacto severo al medioambiente y donde la recuperación de la función del ecosistema tome 10 años o más',
    'Impacto grave en el medioambiente, donde la recuperación de la función del ecosistema tome entre 3 y 10 años',
    'Impacto sustancial en el medioambiente, donde la recuperación de la función del ecosistema tome entre 1 y 3 años',
    'Impacto medible, pero limitado en el medioambiente, donde la recuperación de la función del ecosistema tome menos de 1 año',
    'Impacto menor y temporal en el medioambiente, donde el ecosistema se recupera con poca intervención',
    'No aplica.',
  ]),
  mfl_community: toRows([
    'Impacto severo en la comunidad que dure más de 12 meses o una violación comprobada de los derechos humanos que afecte a 6 o más personas.',
    'Impacto grave en la comunidad que dure de 6 a 12 meses o una violación comprobada de los derechos humanos que afecte a entre 1 y 5 personas.',
    'Impacto grave en la comunidad que dure de 2 a 6 meses.',
    'Impacto medible, pero limitado en la comunidad que dure menos de un mes.',
    'Impacto menor y temporal en la comunidad que se recupera con poca intervención.',
    'No aplica.',
  ]),
  mfl_legal: toRows([
    'Impacto severo en la reputación de la compañía, al atractivo de inversión, los derechos legales o cumplimiento, la propuesta de valor social o la capacidad de acceder a oportunidades a nivel global.',
    'Impacto grave en la reputación de la compañía, al atractivo de inversión, los derechos legales o el cumplimiento, la propuesta de valor social o la capacidad de acceder a oportunidades a nivel nacional.',
    'Impacto sustancial en la reputación de la compañía, los derechos legales o el cumplimiento, la propuesta de valor social o la capacidad de acceder a oportunidades a nivel nacional.',
    'Impacto medible, pero limitado en la reputación de la compañía, derechos legales o cumplimiento, o propuesta de valor social a nivel local (región, ciudad, pueblo).',
    'Impacto menor y temporal en la reputación de la compañía, derechos legales o cumplimiento, o propuesta de valor social',
    'No aplica.',
  ]),
  mfl_reputation: toRows([
    'Impacto severo en la reputación de la compañía, al atractivo de inversión, los derechos legales o cumplimiento, la propuesta de valor social o la capacidad de acceder a oportunidades a nivel global.',
    'Impacto grave en la reputación de la compañía, al atractivo de inversión, los derechos legales o el cumplimiento, la propuesta de valor social o la capacidad de acceder a oportunidades a nivel nacional.',
    'Impacto sustancial en la reputación de la compañía, los derechos legales o el cumplimiento, la propuesta de valor social o la capacidad de acceder a oportunidades a nivel nacional.',
    'Impacto medible, pero limitado en la reputación de la compañía, derechos legales o cumplimiento, o propuesta de valor social a nivel local (región, ciudad, pueblo).',
    'Impacto menor y temporal en la reputación de la compañía, derechos legales o cumplimiento, o propuesta de valor social.',
    'No tiene impacto en la reputación de la compañia.',
  ]),
  mfl_financial: [
    [5, 'US$2000 millones o más.', 1000],
    [4, 'Entre US$250 y US$2000 millones.', 300],
    [3, 'Entre US$50 y US$250 millones.', 100],
    [2, 'Entre US$2 y US$50 millones.', 30],
    [1, 'Menos de US$2 millones.', 10],
  ],
};

const MFL_DESCRIPTIONS_V3 = {
  mfl_health_and_safety: toRows([
    '6 o más muertes o enfermedades crónicas potencialmente mortales',
    'De 1 a 5 muertes o enfermedades crónicas potencialmente mortales',
    'Lesiones o enfermedades incapacitantes a largo plazo o permanentes que alteren la vida de una o más personas',
    'Lesiones o enfermedades que no alteren la vida o incapaciten a corto plazo de una o más personas',
    'Impacto de bajo nivel que resulta solo en primeros auxilios',
    'No aplica.',
  ]),
  mfl_legal: toRows([
    'Impacto severo en los derechos legales de la Compañía o el cumplimiento a nivel global',
    'Impacto grave en los derechos legales de la Compañía o en el cumplimiento a nivel nacional',
    'Impacto moderado en los derechos legales de la Compañía o el cumplimiento a nivel regional',
    'Impacto medible pero limitado en los derechos legales o el cumplimiento de la Compañía',
    'Impacto menor o temporal en los derechos legales o el cumplimiento de la Compañía',
    'No aplica.',
  ]),
  mfl_sustainability: toRows([
    'Impacto significativo y duradero en el medio ambiente, el clima, la comunidad o los pueblos Indígenas',
    'Impacto significativo sobre el medio ambiente, el clima, la comunidad o los pueblos Indígenas',
    'Impacto moderado sobre el medio ambiente, el clima, la comunidad o los pueblos Indígenas',
    'Impacto mensurable pero limitado o temporal en el medio ambiente, el clima, la comunidad o los pueblos Indígenas',
    'Impacto menor y de bajo nivel en el medio ambiente, el clima, la comunidad o los pueblos Indígenas',
    'No aplica.',
  ]),
  mfl_reputation: toRows([
    'Alteración significativa y sostenida de la reputación de la Compañía a nivel global',
    'Alteración significativa y sostenida de la reputación de la Compañía a nivel nacional',
    'Impacto moderado en la reputación de la Compañía a nivel estatal o regional',
    'Impacto medible pero limitado en la reputación de la Compañía a nivel local',
    'Impacto menor y temporal en la reputación de la Compañía',
    'No aplica.',
  ]),
  mfl_financial: [
    [5, 'US$4 mil millones o más', 1000],
    [4, 'Entre US$850 millones y hasta US$4 mil millones', 300],
    [3, 'Entre US$125 millones y hasta US$850 millones', 100],
    [2, 'Entre US$5 millones y hasta US$125 millones', 30],
    [1, 'Menos de US$5 millones', 10],
  ],
};

export const usesGlobalRiskStandardV2 = (globalRiskStandardVersion) => {
  if (globalRiskStandardVersion === null || globalRiskStandardVersion === undefined) {
    return true;
  }
  return globalRiskStandardVersion >= 2;
};

const aliasResiduals = (tables) => {
  const copy = { ...tables };
  copy.health_and_safety_residual = copy.mfl_health_and_safety;
  copy.environment_residual = copy.mfl_environment;
  copy.community_residual = copy.mfl_community;
  copy.legal_residual = copy.mfl_legal;
  copy.reputation_residual = copy.mfl_reputation;
  copy.sustainability_residual = copy.mfl_sustainability;
  copy.financial_residual = copy.mfl_financial;
  return copy;
};

export const buildMflDescriptionTables = (globalRiskStandardVersion) => {
  const base = usesGlobalRiskStandardV2(globalRiskStandardVersion)
    ? MFL_DESCRIPTIONS_V3
    : MFL_DESCRIPTIONS_V1;
  return aliasResiduals(base);
};

export const mflButtonSets = {
  normalV1: {
    mfl_health_and_safety: 'MFL SALUD & SEGURIDAD',
    mfl_environment: 'MFL MEDIOAMBIENTE',
    mfl_community: 'MFL COMUNIDAD',
    mfl_legal: 'MFL Reputación / Legal',
    mfl_financial: 'MFL Financiero',
  },
  normalV2: {
    mfl_health_and_safety: 'MFL Salud y Seguridad',
    mfl_legal: 'MFL Legal',
    mfl_sustainability: 'MFL Sustentabilidad',
    mfl_reputation: 'MFL Reputación',
    mfl_financial: 'MFL Financiero',
  },
  residualV1: {
    health_and_safety_residual: 'ER H&S',
    environment_residual: 'ER ENVIRONMENT',
    community_residual: 'ER COMMUNITY',
    legal_residual: 'ER Reputación / Legal',
    financial_residual: 'ER Financiero',
  },
  residualV2: {
    health_and_safety_residual: 'ER Salud y Seguridad',
    legal_residual: 'ER Legal',
    sustainability_residual: 'ER Sustentabilidad',
    reputation_residual: 'ER Reputación',
    financial_residual: 'ER Financiero',
  },
};

export const getMflButtonSet = (type, globalRiskStandardVersion) => {
  const v2 = usesGlobalRiskStandardV2(globalRiskStandardVersion);
  if (type === 'residual') {
    return v2 ? mflButtonSets.residualV2 : mflButtonSets.residualV1;
  }
  return v2 ? mflButtonSets.normalV2 : mflButtonSets.normalV1;
};

export const impactTypesV1 = [
  { id: 'health_and_safety', name: 'Salud y seguridad' },
  { id: 'environment', name: 'Medioambiente' },
  { id: 'community', name: 'Social y cultural' },
  { id: 'legal', name: 'Reputación / Legal' },
  { id: 'financial', name: 'Financiero' },
];

export const impactTypesV2 = [
  { id: 'health_and_safety', name: 'Salud y Seguridad' },
  { id: 'legal', name: 'Legal' },
  { id: 'sustainability', name: 'Sustentabilidad' },
  { id: 'reputation', name: 'Reputación' },
  { id: 'financial', name: 'Financiero' },
];

export const getImpactTypes = (globalRiskStandardVersion) => (
  usesGlobalRiskStandardV2(globalRiskStandardVersion) ? impactTypesV2 : impactTypesV1
);

export const mflTitleForVersion = (globalRiskStandardVersion) => {
  const v2 = usesGlobalRiskStandardV2(globalRiskStandardVersion);
  return {
    mfl_health_and_safety: 'MFL Salud y Seguridad',
    mfl_environment: 'MFL Medioambiente',
    mfl_community: 'MFL Comunidad',
    mfl_legal: v2 ? 'MFL Legal' : 'MFL Reputación / Legal',
    mfl_reputation: 'MFL Reputación',
    mfl_sustainability: 'MFL Sustentabilidad',
    mfl_financial: 'MFL Financiero',
    health_and_safety_residual: 'Residual de salud y seguridad',
    environment_residual: 'Residual de medioambiental',
    community_residual: 'Residual de comunidad',
    legal_residual: v2 ? 'Residual Legal' : 'Residual Reputación / Legal',
    reputation_residual: 'Residual de reputación',
    sustainability_residual: 'Residual Sustentabilidad',
    financial_residual: 'Residual financiero',
  };
};
